import React, { Component } from "react"
import styled from "styled-components"
import Link from "gatsby-link"
import { SECONDARY_TEXT, ACTIVE_TEXT } from "./consts/colors"
import { TinyButtonWhite } from "./Button"

const FAQData = {
  FAQPage01: "💡 What is TinyMerch?",
  FAQPage02: "🤔 How does this work?",
  FAQPage03: "🖌️ Designing a Product",
  FAQPage04: "💸 Getting Paid",
  FAQPage05: "🤷‍ How do I start?"
}

function FAQLink(props) {
  return <Link {...props} className="FAQLink" activeClassName="FAQLink-active" />
}

const FAQLinkContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 60px;
  top: 60px;
  align-items: center;
  justify-content: center;
  border: 2px solid #f2f2f7;
  div {
    display: flex;
  }
  .FAQLink {
    max-width: 250px;
    padding: 0px 25px;
    color: ${SECONDARY_TEXT};
    :hover {
      color: ${ACTIVE_TEXT};
    }
  }
  .FAQLink-active {
    color: ${ACTIVE_TEXT};
  }
  @media screen and (max-width: 1100px) {
    padding: 0px 50px;
    height: 100px;
    div {
      flex-wrap: wrap;
      justify-content: center;
      .FAQLink {
        padding: 10px 25px;
      }
    }
  }
  @media screen and (max-width: 768px) {
    top: 40px;
  }
  @media screen and (max-width: 615px) {
    height: 175px;
    top: 0px;
    div {
      flex-direction: column;
      align-items: center;

      .FAQLink {
        padding: 5px 25px;
        font-size: 15px;
      }
    }
  }
`

const FAQLinks = styled.div``

const FAQHeader = props => (
  <FAQLinkContainer>
    <div>
      <FAQLink to="/faq/what-is">💡 What is TinyMerch?</FAQLink>
      <FAQLink to="/faq/designing-products">🖌️ Designing a Product</FAQLink>
      <FAQLink to="/faq/getting-paid">💸 Getting Paid</FAQLink>
      <FAQLink to="/faq/how-it-works">🤔 How does this work?</FAQLink>
      <FAQLink to="/faq/how-to-start">🤷‍ How do I start?</FAQLink>
    </div>
  </FAQLinkContainer>
)
export default FAQHeader



// WEBPACK FOOTER //
// ./src/components/FAQHeader.js